import { Box, Grid } from '@mui/material';
import FormView from '../../../../components/views/formView';
import { usePqrTypeForm } from './hook';
import { PqrTypeData } from './data';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    PQR_TYPE,
    PQR_TYPE_DETAIL,
    PQR_TYPE_EDIT,
    PQR_TYPE_NEW,
} from '../../../../../routes/paths';
import { PqrTypeParamsHistorical } from '../historical';

export const PqrTypeForm = () => {
    const {
        pqrType,
        loading,
        handleSubmit,
        handleCleanAndBack,
        setFormikPqrTypeData,
        pqrTypeHistorical,
        showHistorical,
        setShowHistorical,
    } = usePqrTypeForm();

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <FormView
                title={
                    pqrType && pqrType.id ? 'Editar tipo PQR' : 'Crear tipo PQR'
                }
                additionalButtons={
                    <ActionButtonGroup
                        id={pqrType?.id || ''}
                        buttonCreate={{
                            show: Boolean(pqrType?.id),
                            route: PQR_TYPE_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: PQR_TYPE,
                        }}
                        buttonUpdate={{
                            show: true,
                            route: PQR_TYPE_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: PQR_TYPE_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(pqrType?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            />
            {showHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <PqrTypeParamsHistorical
                        historical={pqrTypeHistorical ?? []}
                        showHistorical={true}
                    />
                </Box>
            )}
            <PqrTypeData
                data={pqrType}
                onChangeFormik={(formik) => setFormikPqrTypeData(formik)}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Volver"
                    variant="outlined"
                    onClick={handleCleanAndBack}
                />
            </Grid>
        </>
    );
};
